<template>
  <span class="language-select dropdown " id="language-select">

    <a class="dropdown-toggleX" v-on:click="setShow" href="#" data-toggle="dropdown" id="language1" aria-haspopup="true" aria-expanded="true" v-if="!boolAsButton">
      <i class="" v-bind:class="flag"></i>
    </a>
    <div class="dropdown-menu lng-dropdown-menu" aria-labelledby="language" v-bind:class="{show}" v-if="!boolAsButton">
      <div class="dropdown-item cursor" v-on:click="setLang('us')">
        <span class="flag-icon flag-icon-us"></span>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('hu')">
        <i class="flag-icon flag-icon-hu"></i>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('ie')">
        <i class="flag-icon flag-icon-ie"></i>
      </div>
    </div>


    <a :class="(bgWhite!=='false') ?'dropdown-toggleX btn btn-outline-infoX btn-infoX' : 'dropdown-toggleX btn btn-outline-infoX btn-info'" v-on:click="setShow" href="#" data-toggle="dropdown" id="language2" aria-haspopup="true" aria-expanded="true" v-if="boolAsButton">
      <i class="" v-bind:class="flag"></i>
    </a>
    <div class="dropdown-menu lng-dropdown-menu" aria-labelledby="language" v-bind:class="{show}" style="top:140%" v-if="boolAsButton">
      <div class="dropdown-item cursor" v-on:click="setLang('us')">
        <span class="flag-icon flag-icon-us"></span>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('hu')">
        <i class="flag-icon flag-icon-hu"></i>
      </div>
      <div class="dropdown-item cursor" v-on:click="setLang('ie')">
        <i class="flag-icon flag-icon-ie"></i>
      </div>
    </div>


  </span>
</template>

<script>
  import i18n from '@/i18n';

  export default {
    name: 'LngChooser',
    mounted() {
      const modul = this;
      if (localStorage.getItem("lang")) {
        modul.lang = localStorage.getItem("lang");
      } else {
        if (modul.lngs && modul.lngs.indexOf && modul.lngs.indexOf(navigator.language.substr(0,2))){
          modul.lang = navigator.language.substr(0,2)
        } else {
          modul.lang = modul.lngs[0];
        }
        modul.lang = navigator.language.substr(0,2)
      }


//      if (localStorage.lang) {
//        this.lang = localStorage.lang;
//      }
    },
    data() {
      return {
        lang: "en",
        show: ""
        , flag: "flag-icon flag-icon-us"
        , boolAsButton: true
        , lngs: ['us','en', 'hu', 'ie']
      };
    },
    watch: {
      lang: function (newData, oldData) {
        const modul = this;
        i18n.locale = newData;
        localStorage.setItem("lang",modul.lang);
        modul.flag = "flag-icon flag-icon-" + modul.lang;
        modul.$eventBus.$emit('globalSetLang', newData);
      }
    },
    props: {
      asButton: {
        type: String,
        default: "false",
      },
      bgWhite: {
        type: String,
        default: "false",
      },
    },
    methods: {
      setShow(e){
        const modul = this;
        if (modul.show !== "show") {
          modul.show = "show";
        } else {
          modul.show = "";
        }

        return e;
      },
      setLang(lang){
        const modul = this;
        modul.lang = lang;
        modul.show = "";
        modul.flag = "flag-icon flag-icon-" + lang;
      },
      setCss(){
        const modul = this;
        return (modul.boolAsButton) ? ' btn btn-outline-infoX btn-info ' : 'btn'
      },
//      persist() {
//        localStorage.lang = this.lang;
//      }
    }

  };
</script>

<style>
  .cursor {
    cursor: pointer;
  }
</style>
